import React from 'react';
import './style';

const GstForm = () => {
    return (
        <div className="text-left space-y-4">
          <p>
            I/We, Organizer, do confirm and acknowledge that I am/We are a supplier providing services through an e-commerce platform 
            as per Section 24(IX) of the Central Goods and Services Tax, 2017, under the prevalent GST regime ("GST Laws") and confirm 
            that I/We are not registered under the GST Act, since our annual turnover is below the threshold limit of Rs. 20 Lakhs 
            (supplier supplying only services).
          </p>
        
          <p>
            I/We confirm that any applicable taxes collected on the tickets booked through Dankbarkeit Entertainment LLP’s platform 
            i.e., www.takemytickets.co.in and/or its mobile application and/or other sales channels is our liability and the same 
            shall be duly discharged by us.
          </p>
        
          <p>
            I/We acknowledge that the information furnished above is true to the best of my/our knowledge and that we shall be bound 
            by the acts of duly constituted attorney. In case any of the above information is found to be incorrect at a later date, 
            my membership with your platform shall stand cancelled and any payment or unprocessed bill shall be withheld by you on the 
            basis of the statements given hereinabove. I/We request you to permit and allow our event to be listed on your platform. 
            I/We shall indemnify and hold harmless you and your officers, representatives, affiliates, successors and assigns, against 
            all costs, penalties, damages, or losses or any other charges, penalties, or liabilities incurred in relation to any claim 
            raised pursuant to the following:
          </p>
        
          <ul className="list-disc pl-6 space-y-2 font-bold">
            <li>Breach, violation or non-compliance of any of the provisions contained in this declaration.</li>
            <li>Any act of omission or commission pursuant to which any of the representations given become untrue.</li>
            <li>Violation of any applicable law including GST laws.</li>
            <li>Non-compliance with GST laws.</li>
            <li>Any investigations, inquiries, summons or inspections conducted by any authority.</li>
          </ul>
        
          <p>
            I/We confirm that any applicable taxes collected on the tickets booked through Dankbarkeit Entertainment LLP’s platform 
            i.e., <a href="https://www.takemytickets.co.in" className="text-blue-600 underline">www.takemytickets.co.in</a> 
            and/or its mobile application and/or other sales channels is our liability and the same shall be duly discharged by us.
          </p>
        
          <p>
            I/We acknowledge that the information furnished above is true to the best of my/our knowledge and that we shall be bound 
            by the acts of duly constituted attorney. In case any of the above information is found to be incorrect at a later date, 
            my membership with your platform shall stand cancelled and any payment or unprocessed bill shall be withheld by you on the 
            basis of the statements given hereinabove. I/We request you to permit and allow our event to be listed on your platform. 
            I/We shall indemnify and hold harmless you and your officers, representatives, affiliates, successors and assigns, against 
            all costs, penalties, damages, or losses or any other charges, penalties, or liabilities incurred in relation to any claim 
            raised pursuant to the following:
          </p>
        
          <ul className="list-disc pl-6 space-y-2 font-bold">
            <li>Breach, violation or non-compliance of any of the provisions contained in this declaration.</li>
            <li>Any act of omission or commission pursuant to which any of the representations given become untrue.</li>
            <li>Violation of any applicable law including GST laws.</li>
            <li>Non-compliance with GST laws.</li>
            <li>Any investigations, inquiries, summons, or inspections conducted by any authority.</li>
          </ul>
        
          <p>
            I/We also undertake the responsibility to inform all subsequent changes in the constitution or working of my/our business 
            entity having membership with your platform, affecting the accuracy of the answers given, which will be promptly communicated to you.
          </p>
          </div>
    )
}

export default GstForm;
